module.exports = __webpack_public_path__ + "a17d279f/img/chevron-down-icon.5542f65c.svg";